var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMicrophoneOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .mic_on_a {\n                fill: #fff;\n            }\n\n            .mic_on_b {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mic_on_a",
    d: "M13.909,18.272a3.8,3.8,0,0,0,3.805-3.818l.013-7.636a3.818,3.818,0,0,0-7.636,0v7.636A3.813,3.813,0,0,0,13.909,18.272ZM12.381,6.691a1.527,1.527,0,1,1,3.054,0l-.013,7.891a1.521,1.521,0,1,1-3.042,0Zm8.272,7.763a6.6,6.6,0,0,1-6.745,6.491,6.6,6.6,0,0,1-6.745-6.491H5a8.888,8.888,0,0,0,7.636,8.552v4.174h2.545V23.006a8.867,8.867,0,0,0,7.636-8.552Z",
    transform: "translate(2.606 1.401)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "mic_on_b",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMicrophoneOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_microphone_on.6e94749f47cf4d5d2939ade988396c4a.svg";